/** Inline stroke icons at 1.8px / 22px, traced from the design canvas (frames 1b–1c). */
const S = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.8 } as const;
const R = { strokeLinecap: 'round', strokeLinejoin: 'round' } as const;

export const IconPlay = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M8 5.5L18 12L8 18.5Z" />
  </svg>
);
export const IconPause = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <rect x="7" y="5.5" width="3" height="13" rx="1" />
    <rect x="14" y="5.5" width="3" height="13" rx="1" />
  </svg>
);
export const IconReplay = () => (
  <svg width="21" height="21" viewBox="0 0 24 24" {...S} {...R} aria-hidden>
    <polyline points="3,4.5 3,10 8.5,10" />
    <path d="M4.6 14.8a8 8 0 1 0 1.7-8.8L3 9.5" />
  </svg>
);
export const IconPrev = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" {...S} {...R} aria-hidden>
    <line x1="7" y1="6" x2="7" y2="18" />
    <polyline points="16,7 11,12 16,17" />
  </svg>
);
export const IconNext = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" {...S} {...R} aria-hidden>
    <line x1="17" y1="6" x2="17" y2="18" />
    <polyline points="8,7 13,12 8,17" />
  </svg>
);
export const IconBack = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" {...S} {...R} aria-hidden>
    <polyline points="14.5,5.5 8,12 14.5,18.5" />
  </svg>
);
export const IconMore = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <circle cx="5" cy="12" r="1.7" />
    <circle cx="12" cy="12" r="1.7" />
    <circle cx="19" cy="12" r="1.7" />
  </svg>
);

/** The EN mode glyph (spec §6): filled = show · outline = tap-to-reveal · struck 40% = hide. */
export function EnGlyph({ mode }: { mode: 'show' | 'reveal' | 'hide' }) {
  const base: React.CSSProperties = {
    borderRadius: 6,
    padding: '1px 6px',
    fontSize: 11,
    fontWeight: 700,
    lineHeight: 1.4,
    border: '1.5px solid currentColor',
  };
  if (mode === 'show')
    return (
      <span style={{ ...base, background: 'currentColor' }} aria-hidden>
        <span style={{ color: 'var(--nn-bg)' }}>EN</span>
      </span>
    );
  if (mode === 'hide')
    return (
      <span style={{ ...base, opacity: 0.4, textDecoration: 'line-through' }} aria-hidden>
        EN
      </span>
    );
  return (
    <span style={base} aria-hidden>
      EN
    </span>
  );
}

/** ◀ ▶ nudge handles on the phrase header (frame 1d): 15px chevrons at 1.9px. */
export const IconChevronLeft = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" {...S} strokeWidth={1.9} {...R} aria-hidden>
    <polyline points="14,6.5 8.5,12 14,17.5" />
  </svg>
);
export const IconChevronRight = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" {...S} strokeWidth={1.9} {...R} aria-hidden>
    <polyline points="10,6.5 15.5,12 10,17.5" />
  </svg>
);
